'use strict';

module.exports = {
    FLOW_CHECKOUT_NAME: 'checkout',
    FLOW__CART_NAME: 'cart'
};
